/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GenericModalModule} from '../../generic-modal/generic-modal.module';
import {InputModule} from '../../input/input.module';
import {ConfirmModalComponent} from './confirm-modal.component';

@NgModule({
    declarations: [
        ConfirmModalComponent
    ],
    imports: [
        CommonModule,
        GenericModalModule,
        InputModule
    ],
    exports: [
        ConfirmModalComponent
    ],
    providers: [
        NgbActiveModal
    ]
})
export class ConfirmModalModule {
}
